module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__08-08d9de434c907cbd44c5f0284e4a7050.jpg";